import React, { useState } from 'react';
import '../../assets/css/event2503.css';

import { TopButton } from "../TopButton"
import { Link } from 'react-router-dom';
import { useRef, useEffect } from 'react';
import { gsap } from "gsap";
import { useGSAP } from '@gsap/react';



export default function Event2503() {
    const [showLeftModal, setShowLeftModal] = useState(false);
    const [showRightModal, setShowRightModal] = useState(false);

    useEffect(()=>{
    const titleElement = document.getElementsByTagName('title')[0];
    titleElement.innerHTML = `3월 이벤트 | 어르신본죽왔어요`;
    },[]);

    // gsap.registerPlugin(useGSAP, ScrollTrigger);
    const container = useRef();

    useGSAP(() => {
    let tl01 = gsap.timeline({
        default:{duration: 0.1},
    }); // 인트로

    
    tl01.from('.motiona1', { opacity: 0, y: 100, })
        .from('.motiona2', { opacity: 0, y: 100, })
        .from('.motiona3', { opacity: 0, y: 100, })
        .from('.motiona4', { opacity: 0, y: 100, })

    gsap.to('.motiona6', { scale: 0.95, repeat: -1, yoyo: true, duration: 0.5, })

    }, { scope: container });
    
    

    return (
        <article id='evnet-body' ref={container}>
            
            <TopButton />
    
            <section id='event-top' className='section'>
                <div className='event-inner'>
                    <div className='motiona1'><h2 className='stitle'>정성을 담아 전하는 행복</h2></div>
                    <div className='motiona2 mx350'><img src={process.env.PUBLIC_URL + 'upload/2503/Group_1590.svg'} alt="" /></div>
                    <div className='motiona3'><img src={process.env.PUBLIC_URL + 'upload/2503/intro600.gif'} alt="" /></div>
                    <div className='motiona4 ptext'>홀로 계신 어르신들을 위해 매주 본죽을 나누며
                    따뜻한 마음의 안부를 전하고 있습니다.</div>
                </div>
            </section>
    
    
            <section id='event-about' className='section'>
                <div className="event-inner">
                    <div className='motiona5 col-w'><h2 className='btitle'>2025년 올해도<br />따뜻한 마음을 전해요!</h2></div>
                    <div className='modalClick margin30'>
                        <div className='modal-area'>
                            <div className='left-area' onClick={() => setShowLeftModal(true)}></div>
                            <div className='right-area' onClick={() => setShowRightModal(true)}></div>
                        </div>
                        <img src={process.env.PUBLIC_URL + 'upload/2503/Group_1631.svg'} alt="" />
                    </div>
                    <div className=''><img src={process.env.PUBLIC_URL + 'upload/2503/Group_1632.svg'} alt="" /></div>
                </div>
            </section>
    
    
            <section id='event-join' className='section'>
                <div className="event-inner">
                    <div className='motiona5'><h3 className='mtitle'>참여 이벤트</h3></div>
                    <div className=''><h2 className='btitle'>따뜻한 감동 스토리를<br />애니메이션으로 만나보세요!</h2></div>
                    {/* <div className='margin20'><img src={process.env.PUBLIC_URL + 'upload/2503/Group_1614.svg'} alt="" /></div> */}
                    <iframe className='margin20' width="560" height="230" src="https://www.youtube.com/embed/9FwuI9CzT98?si=2kiYEGZaP0tR9xTC" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                
                    <div className='ptext'>지난 해 공모전 우수작을 바탕으로 만들었어요. 영상을 본 소감과 함께 올해 새롭게 본죽 나눔을 받으실 어르신들께 안부 메시지를 전해주세요.</div>
                    <div className='join-text margin20 ptext'>
                        <div><b>🙋 참여 방법</b> : 위 유튜브 영상 댓글에서 참여가능</div>
                        <div><b>🗓️ 기간</b> : 3월 28일 ~ 4월 7일</div>
                        <div><b>🎁 경품</b> : 쇠고기야채죽 1명, 아메리카노 추첨 10명</div>
                        <p className='stext'>*이벤트 상세 내용은 유튜브 영상 게시글 참고</p>
                    </div>
                    <div className='motiona6'>
                    <Link to='https://youtu.be/9FwuI9CzT98?feature=shared' target="_blank"><img src={process.env.PUBLIC_URL + 'upload/2503/Group_1612.svg'} alt="" /></Link>
                        {/* <button 
                            onClick={() => alert('28일 이벤트가 시작됩니다💗')} 
                            style={{ border: 'none', background: 'none', padding: 0, cursor: 'pointer', width: '100%' }}
                        >
                            <img src={process.env.PUBLIC_URL + 'upload/2503/Group_1612.svg'} alt="" />
                        </button> */}
                    </div>
                    <div className='motiona7 posi-rel'>
                        <img src={process.env.PUBLIC_URL + 'upload/2503/Group_1635.svg'} alt="" />
                    </div>
                </div>
          </section>

          {showLeftModal && (
                <div className="modal-overlay" onClick={() => setShowLeftModal(false)}>
                    <div className="modal-content" onClick={e => e.stopPropagation()}>
                        <button className="modal-close" onClick={() => setShowLeftModal(false)}>×</button>
                        <h2 className="btitle">2025년<br />
                            함께하는 가맹점</h2>
                        <div className="list-box ptext">
                            <Link to='https://naver.me/F2ZbmkUn' target="_blank"><p>📌 본 죽&비빔밥 오금동사거리점</p></Link>
                            <Link to='https://naver.me/5wWzRq9B' target="_blank"><p>📌 본 죽&비빔밥 민락수변공원점</p></Link>
                            <Link to='https://naver.me/GsjGZ2V1' target="_blank"><p>📌 본 죽&비빔밥 대구신매시장점</p></Link>
                            <Link to='https://naver.me/x7nxlddX' target="_blank"><p>📌 본 죽&비빔밥 인천청라SK뷰점</p></Link>
                            <Link to='https://naver.me/FO9nFKJF' target="_blank"><p>📌 본 죽&비빔밥 광주금호푸르지오점</p></Link>
                            <Link to='https://naver.me/IGJBzYAd' target="_blank"><p>📌 본 죽&비빔밥 대전월평트레이더스점</p></Link>
                            <Link to='https://naver.me/5FmfjwUm' target="_blank"><p>📌 본 죽&비빔밥 수원당수점</p></Link>
                            <Link to='https://naver.me/Gj6crjsi' target="_blank"><p>📌 본 죽&비빔밥 원주점</p></Link>
                            <Link to='https://naver.me/FfetDYSA' target="_blank"><p>📌 본 죽&비빔밥 청주우암점</p></Link>
                            <Link to='https://naver.me/x5GfFuzm' target="_blank"><p>📌 본 죽&비빔밥 서천장항점</p></Link>
                            <Link to='https://naver.me/xUwVxHxM' target="_blank"><p>📌 본 죽&비빔밥 전주솔내점</p></Link>
                            <Link to='https://naver.me/xtgJOcTZ' target="_blank"><p>📌 본 죽&비빔밥 순천신대점</p></Link>
                            <Link to='https://naver.me/5Vm9Mrnn' target="_blank"><p>📌 본 죽&비빔밥 포항상원점</p></Link>
                            <Link to='https://naver.me/FDnFV7QM' target="_blank"><p>📌 본 죽&비빔밥 진주판문점</p></Link>
                        </div>
                        
                    </div>
                </div>
            )}

            {showRightModal && (
                <div className="modal-overlay" onClick={() => setShowRightModal(false)}>
                    <div className="modal-content" onClick={e => e.stopPropagation()}>
                        <button className="modal-close" onClick={() => setShowRightModal(false)}>×</button>
                        <h2 className="btitle">2025년<br />
                            함께하는 기관</h2>
                        <div className="list-box ptext">
                            <p>🏢 서울시 송파구재가노인복지기관</p>
                            <p>🏢 수영재가노인지원서비스센터</p>
                            <p>🏢 달구벌재가노인돌봄센터</p>
                            <p>🏢 가좌노인문화센터</p>
                            <p>🏢 서구노인종합복지관</p>
                            <p>🏢 대전광역시사회서비스원 광역종합재가센터</p>
                            <p>🏢 밤밭노인복지관</p>
                            <p>🏢 명륜종합사회복지관</p>
                            <p>🏢 청주가경노인복지관</p>
                            <p>🏢 서천군노인복지관</p>
                            <p>🏢 금암노인복지관</p>
                            <p>🏢 월드비전커뮤니티</p>
                            <p>🏢 사회적협동조합포항나눔지역자활센터</p>
                            <p>🏢 하늘마음노인통합지원센터</p>

                        </div>
                    </div>
                </div>
            )}
       </article>

    )
    
}